<template>
  <div
    :class="[
      'loading full-parent flex-column align-center justify-center',
      { mask },
    ]"
    :style="{ zIndex }"
  >
    <img
      draggable="false"
      class="loading-anim"
      src="~@/assets/images/loading.png"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    zIndex: {
      type: Number,
      default: 2,
    },
    mask: {
      type: Boolean,
      default: true
    }
  },
});
</script>

<style lang="less" scoped>
.loading {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;

  &.mask {
    background: rgba(255, 255, 255, 0.8);
  }

  .loading-anim {
    width: 6vw;
    height: auto;
    object-fit: contain;
  }
}
</style>